import styled from 'styled-components';

import { S3_BUCKET_URL } from '@/constants';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const ScreenFindAiStyles = styled(OnboardingPage)`
  .local-title {
    margin: 0 0 8px;
  }

  ion-content {
    &::part(scroll) {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 26px 0;
    }

    .images-container {
      flex-grow: 1;
      width: 100%;
      aspect-ratio: 1/1;
      background: url(${S3_BUCKET_URL}/layout-own-ai-man/bg-circles.png);
      background-position: center;
      background-size: contain;
      background-size: 360px 360px;
      background-repeat: no-repeat;
      position: relative;
    }
  }
`;

export const ScreenFindAiImageStyles = styled.div`
  font-size: 0;
  line-height: 0;
  aspect-ratio: 1/1;
  position: absolute;
  border-radius: 50%;
  overflow: hidden;

  &:nth-child(1) {
    width: 40%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &:nth-child(2) {
    width: 25%;
    top: 50%;
    left: 50%;
    transform: translate(60%, 60%);
  }

  &:nth-child(3) {
    width: 23%;
    top: 50%;
    left: 50%;
    transform: translate(50%, -180%);
  }

  &:nth-child(4) {
    width: 17%;
    top: 50%;
    left: 50%;
    transform: translate(-235%, 20%);
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
